module.exports = __webpack_public_path__ + "img/bl_red_logo_footer.9bc5c427.png";